import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ECaseNavbarVerticalService
{
    navBarRef;

    constructor()
    {
    }

    setNavBar(ref)
    {
        this.navBarRef = ref;
    }

    getNavBar()
    {
        return this.navBarRef;
    }
}
